<template>
    <UiContextMenu
        :items="menu.items.value"
        :x="menu.state.value?.x ?? 0"
        :y="menu.state.value?.y ?? 0"
        :show="menu.state.value !== null"
        :offset-x="0"
        :offset-y="0"
        :z-index="700"
        @close="menu.close()"
    />
</template>

<script setup lang="ts">
import UiContextMenu from '@src/Common/Components/UI/ContextMenu/ContextMenu.vue';
import type { BlockContextMenuController } from '@src/Common/Builder/useBlockContextMenu';

interface Props {
    menu: BlockContextMenuController;
}

defineProps<Props>();
</script>
